import React from "react";
import { useParams, Navigate } from "react-router-dom";
import ProjectDetail from "./ProjectDetail";
import projectsData from "../data/projects.json";

const ProjectPage = () => {
  const { projectId } = useParams();
  const project = projectsData.find((p) => p.id === projectId);

  if (!project) {
    return <Navigate to="/" replace />;
  }

  return <ProjectDetail project={project} />;
};

export default ProjectPage;
